import { Alert, Button, Col, Row } from 'antd';
import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../App.css';
// import '../auth.css';
import Paper from '@mui/material/Paper';
import { PageFooter } from './HomePage';
import TopNav from '../Components/TopNav';
import { useAuth } from '../contexts/AuthContext';
import MetadataManager from '../Components/MetadataManager';

const Auth = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const { login, register } = useAuth(); 
  const navigate = useNavigate();
  const location = useLocation();

  const isLogin = location.pathname === '/login';
   


  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isLogin) {
        await login({ email, password });
      } else {
        await register({ email, password, passwordConfirm });
      }
      navigate('/dashboard');
    } catch (err) {
      // console.error('Auth error:', err);
      setError(err.response.data.message);
    }
  };

  return (
    
    <div className="container">
      <Row justify="center" className='h-100'>
        <Col xs={24} md={14}>
          <Paper elevation={3} className="auth-paper p-5 bg-dark text-light"> 
            <h2 className="auth-title">{isLogin ? 'Login' : 'Register'}</h2>
            {error && <Alert message={error} type="error" />}
            <form onSubmit={handleSubmit} className="user">
            <div className="form-group mb-2">
              <label>Email</label>
              <input
                type="email"
                className="form-control form-control-user"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="form-group mb-3"> 
              <label>Password</label>
              <input
                type="password"
                className="form-control form-control-user"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            {!isLogin && (
              <div className="form-group mb-5">
                <label>Confirm Password</label>
                <input
                  type="password"
                  className="form-control form-control-user"
                  value={passwordConfirm}
                  onChange={(e) => setPasswordConfirm(e.target.value)}
                />
              </div>
            )}
            {isLogin && (
              <div className="text-end mb-3">
                <Link to="/forgot-password">Forgot Password?</Link>
              </div>
            )}
             <Button type='secondary' onClick={(e)=>handleSubmit(e)} size='large' className="btn btn-primary w-50 ml-auto mr-auto mb-3 mt-5 d-block">
              {isLogin ? 'Login' : 'Register'}
            </Button>
          </form>
          <p className='text-center'>
            {isLogin ? 'Not a member?' : 'Already a member?'} <Link to={isLogin ? '/register' : '/login'}>{isLogin ? 'Register' : 'Login'}</Link>
            </p>
          </Paper>
        </Col>
      </Row>
    </div>
    
  );
};

export function AuthPage2() {
  const location = useLocation();
  const isLogin = location.pathname === '/login';
  
  return (
    <>
      <MetadataManager 
        title={isLogin ? "Login | MenuPortal" : "Register | MenuPortal"}
        description={isLogin ? 
          "Log in to your MenuPortal account to access the API dashboard and manage your integration." : 
          "Create a MenuPortal account to get started with our restaurant data API. Access our sandbox environment."
        }
        keywords={isLogin ? 
          "login, account access, API dashboard, developer login" : 
          "register, create account, API access, developer registration, sandbox access"
        }
      />
      <TopNav dark={true} transparent={false} addClass="home-navbar" />
      <div className="px-4 py-5" style={{ minHeight: '100vh', backgroundColor:'#f8f9fa' }}>
        <div className="row">
          <div className="col-md-3 col-1"></div>
          <div className="col-md-6 col-10">
            <Paper style={{ padding: 32 }} elevation={6}>
                <Auth />
            </Paper>
          </div>
        </div>
      </div>
      <PageFooter />
    </>
  );
}
export default function AuthPage() {
  return (
    <div className='auth-page-wrapper'>
      <TopNav dark={true} customColor='bg-almost-black' transparent={false} />    
      <div className='auth-section'>
        <Auth />
    </div>
      <PageFooter className='bg-almost-black' />
    </div>
  );
}
